// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__wQA7V","head":"ProcedureTableInfo_head__1MC0T"};